import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton,
  VStack, Box, Text,
} from '@chakra-ui/react';
import { useMICUTheme } from '../../lib/micu/MICUThemeProvider';
import { getMedicationList, getMedicationTemplate } from '../../lib/micu/medicationTemplates';
import { addMedication } from '../../lib/micu/micuDatabase';

const MedicationAddModal = ({ isOpen, onClose, caseId, onAdded }) => {
  const navigate = useNavigate();
  const { isDark } = useMICUTheme();
  const meds = getMedicationList();

  const handleSelect = async (templateId) => {
    const template = getMedicationTemplate(templateId);
    const defaultConc = template.defaultConcentrations[0];
    const id = await addMedication(caseId, {
      drugName: template.name,
      templateId,
      concentration: defaultConc.value,
      concentrationUnit: defaultConc.unit,
      dose: null,
      doseUnit: template.defaultDoseUnit,
      rate: null,
      rateUnit: template.defaultRateUnit,
      vtbi: null,
      alarmMinutes: 15,
    });
    onClose();
    if (onAdded) onAdded();
    navigate(`/micu-mobile/case/${caseId}/med/${id}`);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="md">
      <ModalOverlay />
      <ModalContent bg={isDark ? 'micu.bgSecondary' : 'micu.bg'} color="micu.text" mx={4} maxH="80vh">
        <ModalHeader fontSize="lg">Add Medication</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6} overflowY="auto">
          <VStack spacing={2} align="stretch">
            {meds.map(m => (
              <Box
                key={m.key}
                p={3}
                border="1px solid"
                borderColor="micu.border"
                borderRadius="md"
                cursor="pointer"
                _hover={{ borderColor: 'micu.teal', bg: isDark ? 'micu.bgTertiary' : 'micu.bgSecondary' }}
                onClick={() => handleSelect(m.key)}
              >
                <Text fontWeight="600" color="micu.text">{m.name}</Text>
              </Box>
            ))}
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default MedicationAddModal;
